module.exports = __webpack_public_path__ + "static/img/icon_bus.fe15f37d.svg";